import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import React, { Component } from 'react'
import { Provider as AlertProvider } from 'react-alert'
import { Provider as ReduxProvider } from 'react-redux'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { PersistGate as ReduxPersistGate } from 'redux-persist/integration/react'
import PrivateRoute from '../misc/private-route'
import ScrollToTop from '../misc/scroll-to-top'
import { persistor, store } from '../store/store'
import Alerts, { AlertOptions, AlertTemplate } from './alerts'
import IconBackground from './common/icon-background'
import Loading from './common/loading'
import Footer from './footer'
import Header from './header'
import AboutView from './views/about-view'
import FAQsView from './views/faq-view'
import HomeView from './views/home-view'
import IdeaExplorerView from './views/idea-explorer-view'
import IdeaView from './views/idea-view'
import LeaderboardsView from './views/leaderboards-view'
import LoginView from './views/login-view'
import ModeratorView from './views/moderator-view'
import SubmitIdeaView from './views/submit-idea-view'

library.add(fas)

class App extends Component {
    render() {
        
        return (
            <>
                <ReduxProvider store={store}>
                    <ReduxPersistGate
                        loading={<Loading />}
                        persistor={persistor}>
                        <AlertProvider
                            template={AlertTemplate}
                            {...AlertOptions}>
                            <Router>
                                <ScrollToTop>
                                    <Header />
                                    <Alerts />

                                    <div className="container container-fluid flex-fill py-4">
                                        <Switch>
                                            <Route
                                                exact
                                                path="/login"
                                                component={LoginView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/"
                                                component={HomeView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/explore"
                                                component={IdeaExplorerView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/submit"
                                                component={SubmitIdeaView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/leaderboards"
                                                component={LeaderboardsView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/faqs"
                                                component={FAQsView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/about"
                                                component={AboutView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/moderator"
                                                component={ModeratorView}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/idea"
                                                component={IdeaView}
                                            />
                                        </Switch>
                                    </div>

                                    <IconBackground />
                                    <Footer />
                                </ScrollToTop>
                            </Router>
                        </AlertProvider>
                    </ReduxPersistGate>
                </ReduxProvider>
            </>
        )
    }
}

export default App
